module.exports = __webpack_public_path__ + "img/logo_1.6091eda.png";